import { render, staticRenderFns } from "./DataInput.vue?vue&type=template&id=c6822118&"
import script from "./DataInput.vue?vue&type=script&lang=js&"
export * from "./DataInput.vue?vue&type=script&lang=js&"
import style0 from "./DataInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports